import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useQuery } from 'react-query'

import { GenericErrorContent } from '@/components/GenericErrorContent'
import { Layout } from '@/components/Layout'
import { MobileBottomContainerFixed } from '@/components/MobileBottomContainerFixed'
import { MobileBottomMenu } from '@/components/MobileBottomMenu'
import { useAuthentication } from '@/context/AuthProvider'
import { suggestedOnboardingPath } from '@/i18n-routes'
import { httpQueryFunction, SuggestedCriteria, initApi as glugluPrivateApi } from '@/lib/api-gluglu-auth'
import { UserValuation } from '@/pages/profile/suggested'
import { buildRelativeLocalizedLink } from '@/utils/navigation'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'

import { PropertiesList } from './PropertiesList'
import { genericErrorBackground } from './style.css'

export const Feed: React.FC<{ userValuation?: UserValuation; userValuationSessionId?: string }> = ({
  userValuation,
  userValuationSessionId,
}) => {
  const { lang } = useTranslation()
  const { isLoading: isUserLoading, user } = useAuthentication()
  const router = useRouter()
  const {
    data: suggestedCriteria,
    error,
    isFetching,
    status,
  } = useQuery<SuggestedCriteria>([glugluPrivateApi().getSuggestionCriteriaURL, user?.id], httpQueryFunction, {
    enabled: !isUserLoading && !!user,
    retry: false,
  })

  useEffect(() => {
    if (status === 'success' && !suggestedCriteria) {
      router.push(buildRelativeLocalizedLink(suggestedOnboardingPath, lang))
    }
  }, [suggestedCriteria, status, router, lang])

  if (isFetching || isUserLoading || (!suggestedCriteria && status === 'success')) return null
  if (error) {
    return (
      <Layout contentWidth="default" showFooterOnMobile={false}>
        <div className={genericErrorBackground}>
          <GenericErrorContent gtmCategory={GTMEventCategory.SuggestedPage} />
        </div>
        <footer>
          <MobileBottomContainerFixed>
            <MobileBottomMenu activeButton="suggested" />
          </MobileBottomContainerFixed>
        </footer>
      </Layout>
    )
  }
  return (
    <PropertiesList
      criteria={suggestedCriteria}
      userValuation={userValuation}
      userValuationSessionId={userValuationSessionId}
    />
  )
}
